// Handle subscription widget toggling for dynamically rendered quickshop modals.
document.addEventListener('click', (event) => {
  const label = event.target.closest('.inside-modal label[data-variant-id]');
  if (!label) return;

  const quickshopModal = label.closest('.quickshop.modal');
  if (!quickshopModal) return;

  const variantId = label.dataset.variantId;
  if (!variantId) return;

  const allSubscriptionWidgets = quickshopModal.querySelectorAll('.subscription-widget__variant');
  allSubscriptionWidgets.forEach((widget) => {
    widget.classList.add('hidden');
  });

  const subscriptionWidget = quickshopModal.querySelector(`.subscription-widget__variant-${variantId}`);
  if (!subscriptionWidget) return;

  subscriptionWidget.classList.remove('hidden');
});